import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    subtitle: {
      color: theme.text.secondary,
      lineHeight: "22px",
    },
    benefitCard: {
      alignItems: "center",
      backgroundColor: theme.goal.harvest.maximize,
      borderRadius: constants.radius.view,
      display: "flex",
      flexDirection: "row",
      paddingLeft: spacing.m,
      paddingRight: spacing.m,
      paddingTop: spacing.s,
      paddingBottom: spacing.s,
    },
    benefitIcon: {
      flexShrink: 0,
      marginRight: spacing.s,
    },
    benefitCaption: {
      flex: 1,
      fontSize: 10,
      lineHeight: "14px",
    },
    legalSection: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    footerText: {
      color: theme.text.secondary,
      fontSize: 9,
      fontStyle: "italic",
      lineHeight: "12px",
      textAlign: "center",
      whiteSpace: "pre-line",
    },
    disclosureRow: {
      display: "flex",
      justifyContent: "center",
    },
    disclosureText: {
      fontSize: 11,
      textAlign: "center",
    },
  };

  return styles;
};
